import i18n from "i18next";
import { HazardIdEnum, LocationRiskAssessment, PageTabs, PolicyDetails } from "../hazardIdEnum";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

const protezioneCivileColorRange = ["green", "yellow", "orange", "red"];
const today: string = " 1";
const tomorrow: string = " 2";

const oneProtezioneCivileHazard = (
  cysId: HazardIdEnum,
  permissionId: PermissionIdEnum,
  label: string,
): Hazard => ({
  cysId: cysId,
  name: label,
  permissions: [permissionId],
  colorRange: protezioneCivileColorRange,
  description: i18n.t("riskExposureMapExplained.protezioneCivile"),
  label: label,
  pages: [PolicyDetails, LocationRiskAssessment],
  pageTab: PageTabs.warningTab,
});

export const getProtezioneCivileHazardsList = (): Hazard[] => [
  oneProtezioneCivileHazard(
    HazardIdEnum.LandslideTodayPrc,
    PermissionIdEnum.LandslideTodayPrc,
    `${i18n.t("riskAssessment.landslide")} ${i18n.t("riskAssessment.day")} ${today} (PRC)`,
  ),
  oneProtezioneCivileHazard(
    HazardIdEnum.ThunderstormTodayPrc,
    PermissionIdEnum.ThunderstormTodayPrc,
    `${i18n.t("riskAssessment.thunderstorm")} ${i18n.t("riskAssessment.day")} ${today} (PRC)`,
  ),
  oneProtezioneCivileHazard(
    HazardIdEnum.FloodTodayPrc,
    PermissionIdEnum.FloodTodayPrc,
    `${i18n.t("riskAssessment.flood")} ${i18n.t("riskAssessment.day")} ${today} (PRC)`,
  ),
  oneProtezioneCivileHazard(
    HazardIdEnum.LandslideTomorrowPrc,
    PermissionIdEnum.LandslideTomorrowPrc,
    `${i18n.t("riskAssessment.landslide")} ${i18n.t("riskAssessment.day")} ${tomorrow} (PRC)`,
  ),
  oneProtezioneCivileHazard(
    HazardIdEnum.ThunderstormTomorrowPrc,
    PermissionIdEnum.ThunderstormTomorrowPrc,
    `${i18n.t("riskAssessment.thunderstorm")} ${i18n.t("riskAssessment.day")} ${tomorrow} (PRC)`,
  ),
  oneProtezioneCivileHazard(
    HazardIdEnum.FloodTomorrowPrc,
    PermissionIdEnum.FloodTomorrowPrc,
    `${i18n.t("riskAssessment.flood")} ${i18n.t("riskAssessment.day")} ${tomorrow} (PRC)`,
  ),
];
